// Stree: hover a colour swatch on a product card to preview that colourway's photo in place (click still opens it).
// Dawn fades the card's SECOND photo in on card hover, so every <img> in the media box is swapped, not just the first.
// Smoothness rules (14 Oct 2026): the preview uses the same CDN sizes the cards already load (hot cache, ~0.4 s, not the
// on-demand 900 px resize that took 7 s), every colourway is preloaded the moment the card is hovered, the swap waits
// for the image to be decoded, the box fades for 120 ms around the swap, the latest hover always wins, and the "shown"
// dot restores the original photo.
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  if (!canHover) return;
  var WIDTHS = [165, 360, 533, 720, 940, 1066], FADE = 120, decoded = {};
  function ladder(url) { return WIDTHS.map(function (w) { return url.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', '); }
  function preload(url, sizes) {
    if (decoded[url]) return decoded[url];
    var im = new Image(); if (sizes) im.sizes = sizes; im.srcset = ladder(url); im.src = url;
    decoded[url] = (im.decode ? im.decode() : Promise.resolve()).catch(function () {});
    return decoded[url];
  }
  function media(card) { return card ? card.querySelector('.card__media .media') : null; }
  function images(card) { return card ? Array.prototype.slice.call(card.querySelectorAll('.card__media img')) : []; }
  function remember(img) {
    if (img.dataset.streeSrc !== undefined) return;
    img.dataset.streeSrc = img.getAttribute('src') || ''; img.dataset.streeSrcset = img.getAttribute('srcset') || ''; img.dataset.streeAlt = img.getAttribute('alt') || '';
  }
  function apply(card, url, alt) {
    images(card).forEach(function (img) {
      remember(img);
      if (url) { img.setAttribute('srcset', ladder(url)); img.src = url; img.alt = alt || img.alt; }
      else { if (img.dataset.streeSrcset) img.setAttribute('srcset', img.dataset.streeSrcset); else img.removeAttribute('srcset'); img.src = img.dataset.streeSrc; img.alt = img.dataset.streeAlt; }
    });
  }
  // one preview state per card: which url is wanted; a stale load never overwrites a newer hover
  function show(card, url, alt) {
    var box = media(card); if (!box) return;
    card.dataset.streeWant = url || '';
    var sizes = (images(card)[0] || {}).sizes;
    (url ? preload(url, sizes) : Promise.resolve()).then(function () {
      if (card.dataset.streeWant !== (url || '')) return;        // moved on already
      if (card.dataset.streeShown === (url || '')) return;       // nothing to change
      box.classList.add('stree-fading');
      setTimeout(function () {
        if (card.dataset.streeWant !== (url || '')) { box.classList.remove('stree-fading'); return; }
        apply(card, url, alt); card.dataset.streeShown = url || '';
        requestAnimationFrame(function () { box.classList.remove('stree-fading'); });
      }, FADE);
    });
  }
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var card = t.closest('.card-wrapper');
    if (!card || card.dataset.streeWarm !== '1') {           // first touch of a card: warm every colourway
      if (card) { card.dataset.streeWarm = '1'; var sizes = (images(card)[0] || {}).sizes;
        card.querySelectorAll('a.stree-swatch[data-swatch-image]').forEach(function (a) { preload(a.dataset.swatchImage, sizes); }); }
    }
    var sw = t.closest('.stree-swatch');
    if (!sw || !card) return;
    var row = sw.closest('.stree-swatches');
    row.querySelectorAll('.is-previewing').forEach(function (x) { x.classList.remove('is-previewing'); });
    if (sw.dataset.swatchImage) { sw.classList.add('is-previewing'); row.classList.add('is-previewing'); show(card, sw.dataset.swatchImage, sw.dataset.swatchAlt); }
    else { row.classList.remove('is-previewing'); show(card, null); }   // the "shown" dot: back to this product's own photo
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.stree-swatch');
    if (!sw) return;
    var row = sw.closest('.stree-swatches'), to = e.relatedTarget;
    if (to && to.closest && to.closest('.stree-swatches') === row) return;   // moving between dots
    row.querySelectorAll('.is-previewing').forEach(function (x) { x.classList.remove('is-previewing'); });
    row.classList.remove('is-previewing');
    show(sw.closest('.card-wrapper'), null);
  });
})();

// ---- wishlist (localStorage) --------------------------------------------------------------
(function () {
  var KEY = 'stree_wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} paint(); }
  function paint() {
    var list = read();
    document.querySelectorAll('.stree-wish').forEach(function (b) { var saved = list.indexOf(b.dataset.handle) >= 0; b.classList.toggle('is-saved', saved); b.title = saved ? 'Saved — tap to remove' : 'Save to wishlist'; b.setAttribute('aria-pressed', saved ? 'true' : 'false'); var lb = b.querySelector('.stree-wish__label'); if (lb) lb.textContent = saved ? 'Saved to wishlist' : 'Add to wishlist'; });
    var c = document.querySelector('.stree-wish-count'); if (c) { c.textContent = list.length; c.hidden = list.length === 0; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.stree-wish'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var list = read(), h = b.dataset.handle, i = list.indexOf(h);
    if (i >= 0) list.splice(i, 1); else list.unshift(h);
    write(list);
  });
  document.addEventListener('DOMContentLoaded', paint); paint();
  document.addEventListener('shopify:section:load', paint);

  // wishlist page
  var grid = document.getElementById('stree-wishlist-grid');
  if (grid) {
    var money = function (cents) { var f = (window.STREE_MONEY || 'Rs. {{amount}}'); var n = (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); return f.replace(/\{\{\s*amount[^}]*\}\}/, n); };
    var render = function () {
      var list = read(); grid.innerHTML = '';
      document.getElementById('stree-wishlist-empty').hidden = list.length > 0;
      var share = document.getElementById('stree-wishlist-share'); share.hidden = list.length === 0;
      if (!list.length) return;
      Promise.all(list.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
        var lines = [];
        ps.forEach(function (p, idx) {
          if (!p) return;
          lines.push('• ' + p.title + ' — ' + location.origin + '/products/' + p.handle);
          var el = document.createElement('div'); el.className = 'stree-wishlist__item';
          el.innerHTML = '<a href="/products/' + p.handle + '"><img src="' + (p.featured_image || '') + '" alt=""><h3>' + p.title.replace(/Co-ord/g, 'Co\u2011ord') + '</h3><div class="price">' + money(p.price) + (p.available ? '' : ' · sold out') + '</div></a><button type="button" data-remove="' + p.handle + '">Remove</button>';
          grid.appendChild(el);
        });
        share.querySelector('a').href = 'https://wa.me/' + (window.STREE_WA || '') + '?text=' + encodeURIComponent('Hi Stree, these are the pieces on my wishlist:\n' + lines.join('\n'));
      });
    };
    grid.addEventListener('click', function (e) { var b = e.target.closest('[data-remove]'); if (!b) return; var list = read(); write(list.filter(function (h) { return h !== b.dataset.remove; })); render(); });
    render();
  }
})();

// ---- "similar pieces" popover on cards ------------------------------------------------------
(function () {
  function close() { document.querySelectorAll('.stree-similar-pop').forEach(function (p) { p.remove(); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.stree-similar');
    if (!b) { if (!e.target.closest('.stree-similar-pop')) close(); return; }
    e.preventDefault(); e.stopPropagation();
    var wasOpen = !!b.closest('.stree-card-actions').querySelector('.stree-similar-pop');
    close();
    if (wasOpen) return; // second tap on the same button closes it
    var sims = []; try { sims = JSON.parse(b.dataset.similar || '[]'); } catch (err) {}
    var pop = document.createElement('div'); pop.className = 'stree-similar-pop';
    var html = '<button type="button" class="stree-similar-pop__close" aria-label="Close">×</button>';
    if (sims.length) { html += '<p class="stree-similar-pop__title">Same design, other colours</p><div class="stree-similar-pop__row">' + sims.map(function (s) { return '<a href="' + s.h + '"><img src="' + s.i + '" alt="' + s.c + '">' + s.c + '</a>'; }).join('') + '</div>'; }
    else { html += '<p class="stree-similar-pop__title">This design comes in one colour</p>'; }
    if (b.dataset.fabric) html += '<a class="stree-similar-pop__more" href="' + b.dataset.fabricUrl + '">More pieces in ' + b.dataset.fabric + ' →</a>';
    pop.innerHTML = html;
    b.closest('.stree-card-actions').appendChild(pop);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

// ---- bag icon on cards: add to bag straight away when the piece has one size and is in stock ----------
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.stree-bag');
    if (!a) return;
    if (a.dataset.variants !== '1' || a.dataset.available !== 'true' || !a.dataset.variant) return; // falls through to the product page
    e.preventDefault(); e.stopPropagation();
    a.classList.add('is-busy'); window.streeProgress && window.streeProgress.start();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(a.dataset.variant), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) { if (x.ok) { window.location.href = '/cart'; } else { a.classList.remove('is-busy'); window.streeProgress && window.streeProgress.done(); alert(x.j.description || x.j.message || 'Could not add to bag'); } })
      .catch(function () { a.classList.remove('is-busy'); window.streeProgress && window.streeProgress.done(); window.location.href = a.href; });
  });
})();

// ---- instant feedback on every click: top progress bar + prefetch of likely next pages -----------------
(function () {
  var bar = document.createElement('div'); bar.id = 'stree-progress';
  if (document.body) document.body.appendChild(bar); else document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(bar); });
  var t;
  window.streeProgress = {
    start: function () { clearTimeout(t); bar.classList.add('is-on'); bar.style.width = '18%'; t = setTimeout(function () { bar.style.width = '70%'; }, 150); setTimeout(function () { if (bar.classList.contains('is-on')) bar.style.width = '88%'; }, 2500); },
    done: function () { clearTimeout(t); bar.style.width = '100%'; setTimeout(function () { bar.classList.remove('is-on'); bar.style.width = '0'; }, 250); }
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.getAttribute('href').charAt(0) === '#' || a.closest('.stree-card-actions')) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
    window.streeProgress.start();
  });
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.method && f.method.toLowerCase() === 'get') window.streeProgress.start(); });
  window.addEventListener('pageshow', function () { window.streeProgress.done(); });
  // prefetch product / collection / page documents the moment a finger lands on their link
  var seen = {};
  function prefetch(e) {
    var a = e.target.closest && e.target.closest('a[href^="/products/"], a[href^="/collections/"], a[href^="/pages/"]');
    if (!a) return; var href = a.getAttribute('href').split('#')[0]; if (!href || seen[href]) return; seen[href] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = href; l.as = 'document'; document.head.appendChild(l);
  }
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('mouseover', prefetch, { passive: true });
})();
